import { notification, Tabs } from 'antd';
import { CustomizeSettings } from './components/customize-settings/customize-settings';
import { NotificationSettings } from './components/notification-settings/notification-settings';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { getWpBookrSettings, saveWpSettings } from '../../core/services/wp-settings.service';
import { BookrWpOptions } from '../../core/models/bookr-wp-options';
import { GeneralSettings } from './components/general-settings/general-settings';

export const SettingsPage: React.FC = () => {
	const { t } = useTranslation();
	const [wpBookrOptions, setWpBookrOptions] = useState<BookrWpOptions>();
	const [api, contextHolder] = notification.useNotification();

	useEffect(() => {
		const loadWpBookrSettings = async () => {
			const response = await getWpBookrSettings();
			setWpBookrOptions(response);
		};

		loadWpBookrSettings();
	}, []);

	async function onSaveBookrOptions() {
		if (!wpBookrOptions) return;

		try {
			await saveWpSettings(wpBookrOptions);

			api.success({
				message: t('backEnd.saveSettings'),
			});
		} catch (error: any) {
			api.error({
				message: 'Error occured',
				description: error?.message,
			});
		}
	}

	const tabItems = [
		{
			label: t('backEnd.settings.general.title'),
			key: 'general',
			children: <GeneralSettings bookrWpOptions={wpBookrOptions} onChange={setWpBookrOptions} onClickSave={onSaveBookrOptions} />,
		},
		{
			label: t('backEnd.settings.customize.title'),
			key: 'customize',
			children: <CustomizeSettings bookrWpOptions={wpBookrOptions} onChange={setWpBookrOptions} onClickSave={onSaveBookrOptions} />,
		},
		{
			label: t('backEnd.settings.notification.title'),
			key: 'notifications',
			children: <NotificationSettings bookrWpOptions={wpBookrOptions} onChange={setWpBookrOptions} onClickSave={onSaveBookrOptions} />,
		},
	];

	return (
		<>
			{contextHolder}
			<Tabs tabPosition={'left'} items={tabItems} />
		</>
	);
};
